export const ERROR_MESSAGES = {
    CS_ENTRY_NOT_FOUND: ({ locale, entry, contentType, }) => `CMS entry not found for locale "${locale}", entry: "${entry}" and contentType: "${contentType}"`,
    CS_ICON_NOT_FOUND: ({ locale, entry }) => `CMS icon not found for locale "${locale}" and entry: "${entry}"`,
    CS_CONTENT_TYPE_NOT_FOUND: ({ contentType }) => `There was an error fetching the ${contentType} from ContentStack`,
};
export const TechnicalErrorCode = 'technicalError';
//# sourceMappingURL=errors.js.map